import $dom from 'cash-dom';
import Glide from '@glidejs/glide';

const machineSelector = () => {
  const $machineUpsellElem = $dom('[data-machine-upsell]');
  const $machineUpsellElemControls = $dom('[data-machine-upsell-controls]');
  const $numberOfItems = $machineUpsellElem.find('.glide__slide').length;
  const windowWidth = window.innerWidth;
  if ($machineUpsellElem.length === 0 || $numberOfItems === 0) {
    return false;
  }

  if (
    ($numberOfItems <= 2 && windowWidth < 1024) ||
    ($numberOfItems <= 4 && windowWidth >= 1024)
  ) {
    if (__DEV__) {
      console.info(
        `Glide arrows are hidden as there are: ${$numberOfItems} items (or less) for screen size: ${windowWidth}`
      );
    }
  }

  const glide = new Glide($machineUpsellElem[0], {
    type: 'slider',
    startAt: 0,
    perView: 4,
    bound: true,
    breakpoints: {
      1020: {
        perView: 2
      }
    }
  }).mount();

  $machineUpsellElemControls.on('click', '[data-glide-dir]', e => {
    const { glideDir } = e.currentTarget.dataset;

    glide.go(glideDir);
  });
};

export default machineSelector;
